import React, { useState, useEffect } from "react";
import "./MissingLayersModal.css";
import AddIcon from "@mui/icons-material/Add";
import layerLibrary from "../../canvas/LayerLibrary";

const MissingLayersModal = ({ layers, onClose, onLayerAdded }) => {
  const [selectedLayer, setSelectedLayer] = useState(null);
  const [form, setForm] = useState({
    layerName: "",
    datatypeName: "",
    color: "#f5eee1",   // ✅ no alpha,
    opacity: 0.4
  });

  useEffect(() => {
    if (layers.length === 0) onClose();
  }, [layers, onClose]);

  const handleAddClick = (layer) => {
    setSelectedLayer(layer);
    setForm({
      layerName: `L${layer.layer_number}`,
      datatypeName: `drawing`,
      color: "#f5eee1",   // ✅ no alpha,
      opacity: 0.4
    });
  };

  const handleSave = () => {
    if (!selectedLayer) return;

    layerLibrary.layers.push({
      layer_name: form.layerName,
      datatype_name: form.datatypeName,
      layer_number: selectedLayer.layer_number,
      datatype_number: selectedLayer.datatype_number,
      color: form.color,
      pattern: { opacity: form.opacity }
    });

    layerLibrary.persistDebounced?.();
    onLayerAdded(selectedLayer);

    setSelectedLayer(null);
    setForm({
    layerName: `L${selectedLayer.layer_number}`, // ✅ L + layer number
    datatypeName: "drawing",              // ✅ default datatype name
    color: "#f5eee1",   // ✅ no alpha,
    opacity: 0.4
  });
  };

  return (
    <div className="ml-overlay">
      <div className="ml-modal ml-split">
        <h3 className="ml-title">⚠️ Missing Layers Detected</h3>

        <div className="ml-body">
          {/* LEFT PANEL */}
          <div className="ml-left">
            {layers.map((l) => (
              <div
                key={`${l.layer_number}:${l.datatype_number}`}
                className="ml-row"
              >
                <div className="ml-row-text">
                  <b>{l.layer_number}</b> / <b>{l.datatype_number}</b>
                </div>

                <AddIcon
                  className="ml-add-icon"
                  onClick={() => handleAddClick(l)}
                />
              </div>
            ))}
          </div>

          {/* RIGHT PANEL */}
          <div className="ml-right">
            <div className="ml-field readonly">
              <label>Layer #</label>
              <input value={selectedLayer?.layer_number ?? ""} disabled />
            </div>

            <div className="ml-field readonly">
              <label>Datatype #</label>
              <input value={selectedLayer?.datatype_number ?? ""} disabled />
            </div>

            <div className="ml-field">
              <label>Layer Name</label>
              <input
                value={form.layerName}
                disabled={!selectedLayer}
                onChange={(e) =>
                  setForm({ ...form, layerName: e.target.value })
                }
              />
            </div>

            <div className="ml-field">
              <label>Datatype Name</label>
              <input
                value={form.datatypeName}
                disabled={!selectedLayer}
                onChange={(e) =>
                  setForm({ ...form, datatypeName: e.target.value })
                }
              />
            </div>

            {/* COLOR PICKER */}
            <div className="ml-field">
              <label>Color</label>
              <input
                type="color"
                value={form.color}
                disabled={!selectedLayer}
                onChange={(e) =>
                  setForm({ ...form, color: e.target.value })
                }
              />
            </div>

            {/* OPACITY SLIDER */}
            <div className="ml-field">
              <label>Opacity</label>
              <div className="ml-slider">
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.05"
                  value={form.opacity}
                  disabled={!selectedLayer}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      opacity: Number(e.target.value)
                    })
                  }
                />
                <span>{form.opacity}</span>
              </div>
            </div>

            
          </div>
        </div>

        <div className="ml-actions">
  <button
    className="primary"
    onClick={handleSave}
    disabled={!selectedLayer}
  >
    Save Layer
  </button>

  <button onClick={onClose}>Close</button>
</div>

      </div>
    </div>
  );
};

export default MissingLayersModal;
